<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-4 px-8">
        <div class="page text-white">Settings</div>
        <div></div>
      </div>
    </lcontainer>
    <div>
      <lcontainer>
        <div class="py-4 px-8 flex flex-wrap">
          <div class="w-full md:w-1/2 items-center form-row my-4 px-4">
            <div class="flex flex-wrap justify-between">
              <page-header class="py-2 tenant-main-color"
                >User Information</page-header
              >
            </div>
            <div class="">
              <div class="flex flex-row items-center form-row mb-8">
                <div class="modal-field font-semibold">First Name:</div>
                <div class="flex-grow ml-auto">
                  <linput
                    type="text"
                    name="fname"
                    v-model="form.first_name"
                    :errorMessage="errors.first_name"
                    :error="errors.first_name"
                    placeholder="First Name"
                  />
                </div>
              </div>
              <div class="flex flex-row items-center form-row mb-8">
                <div class="modal-field font-semibold ">Last Name:</div>
                <div class="flex-grow ml-auto">
                  <linput
                    type="text"
                    v-model="form.last_name"
                    :errorMessage="errors.last_name"
                    :error="errors.last_name"
                    placeholder="Last Name"
                  />
                </div>
              </div>
              <div class="flex flex-row items-center form-row mb-8">
                <div class="modal-field font-semibold ">Email:</div>
                <div class="flex-grow ml-auto">
                  <linput
                    type="email"
                    v-model="form.email"
                    :errorMessage="errors.email"
                    :error="errors.email"
                    placeholder="Email"
                  />
                </div>
              </div>

              <div class="flex flex-row items-center form-row mb-8">
                <div class="modal-field font-semibold">Gender:</div>
                <div class="flex-grow ml-auto">
                  <lselect
                    :error="errors.gender"
                    v-model="form.gender"
                    :items="gender"
                    :editValue="form.gender"
                    placeholder="Select Gender"
                  />
                </div>
              </div>
              <div class="flex flex-row items-center form-row mb-8">
                <div class="modal-field font-semibold ">Phone Number:</div>
                <div class="flex-grow ml-auto">
                  <linput
                    type="text"
                    name="phone"
                    :error="errors.phone_number"
                    :errorMessage="errors.phone_number"
                    v-model="form.phone_number"
                    placeholder="Phone Number"
                  />
                </div>
              </div>

              <div class="flex flex-row items-center form-row mb-8">
                <div class="modal-field font-semibold ">Company Name:</div>
                <div class="flex-grow ml-auto">
                  <linput
                    type="text"
                    name="phone"
                    :error="errors.company_name"
                    :errorMessage="errors.phone_number"
                    v-model="form.company_name"
                    placeholder="Company Name"
                  />
                </div>
              </div>
            </div>

            <lms-button
              @click="handleFormSubmit"
              class="m-2 inline"
              textColor="#fff"
              >Save Profile</lms-button
            >
          </div>
          <div class="w-full md:w-1/2 items-center form-row my-4 px-4">
            <div>
              <div class="flex flex-wrap justify-between">
                <page-header class="py-2 tenant-main-color"
                  >Security</page-header
                >
              </div>
              <div class="flex flex-row justify-between my-4">
                <div class="tenant-main-color font-semibold">Password:</div>
                <div>
                  <p>***********</p>
                </div>
              </div>
            </div>
            <lms-button
              @click="$Bus.$emit('update-password')"
              class="m-2 inline"
              textColor="#fff"
              >Update Password</lms-button
            >
          </div>
        </div>
      </lcontainer>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  components: {
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
    lselect: () => import("@/components/forms/select"),
    ltextarea: () => import("@/components/general/textarea"),
    LmsOutlineButton: () => import("@/components/general/outline_button"),
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        gender: "",
        role: "",
      },
      errors: [],
      error: {},
      user: {},
      search: "",
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      gender: [
        {
          text: "Male",
          value: "male",
        },
        {
          text: "Female",
          value: "female",
        },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["fetchAdminRoles", "updateProfile", "fetchProfile"]),
    async handleFormSubmit() {
      this.errors = [];
      this.updateLoader(true);
      let res = await this.updateProfile(this.form);
      this.updateLoader(false);
      if (res.status == 200) {
        this.$emit("notify", {
          type: "success",
          message: "Profile successfully",
        });
        this.close();
      } else {
        if (res.status == 400) {
          this.$Bus.$emit("notify", {
            type: "error",
            message: res.data.errors
              ? res.data.errors[0].title
              : "An error occured",
          });
        }
      }
    },
  },
  async mounted() {
    let res = await this.fetchProfile();
    this.user = res.data.data.user;
    let company_name = this.user.tenant_profile.company_name;
    let { email, first_name, gender, last_name, phone_number } = this.user;
    this.fetchAdminRoles();
    this.form = {
      email,
      first_name,
      gender,
      last_name,
      phone_number,
      company_name,
    };
  },
};
</script>
<style scoped></style>
